import React from "react";

// Candidate wording for official (staff-verified) bonus states; self-reported targets are never "Verified".
export const CANDIDATE_STATE = { earned: "Earned · Verified", qualified: "Qualified · Verified", pending_validation: "Target Met — Self-Reported",
  in_progress: "In Progress", not_started: "Not Yet Met", expired: "Deadline Passed" };

export function OwnershipReadiness({ reqs, rows }) {
  const g1 = (rows || []).find((x) => x.key === "g1");
  return (
    <section className="rounded-xl border border-slate-200 bg-white" data-testid="ms-ownership">
      <h2 className="font-display text-lg font-semibold text-slate-900 px-4 pt-3">Requirements for Full-Time Agency Ownership</h2>
      <p className="text-xs text-slate-500 px-4 pb-2">Production alone does not complete your pathway — every item below is required.</p>
      {(reqs || []).map((q) => (
        <div key={q.key} className="flex items-center justify-between gap-3 px-4 py-2 border-t border-slate-100 text-sm" data-testid={`ms-req-${q.key}`}>
          <span className="text-slate-800">{q.key === "grad1" ? "Graduation Level 1 / applicable production requirement" : q.label}</span>
          <span className="text-xs font-semibold text-slate-600 whitespace-nowrap">{q.key === "grad1" ? (CANDIDATE_STATE[g1?.state] || "—") : q.status_label}</span>
        </div>))}
    </section>
  );
}
